import type {
  ProductCardKind,
  ProductCardTone,
} from '~/utils/productCardMapper'

const TINTED_CLASSES: Record<ProductCardKind, string> = {
  sale: 'bg-orange-50 border-orange-400/40',
  kit: 'bg-teal-50 border-teal-200',
  online: 'bg-stone-100 border-stone-300/70',
  plain: 'bg-white border-stone-300/70',
}

/** Background + border for the V2 card; `tinted` colours the card by kind. */
export const getProductCardToneClass = (
  tone: ProductCardTone,
  kind: ProductCardKind
): string => TINTED_CLASSES[tone === 'tinted' ? kind : 'plain']
